export default "__VITE_ASSET__f9b13da9__"